import {onError} from '@apollo/client/link/error'
import {isClient} from '../../../utils'
import config from 'config'

function getLoginRedirectLink(cookies, {redirect, serverContext, customLoginUrl}) {
  return onError(({response, graphQLErrors}) => {
    if (graphQLErrors) {
      graphQLErrors.find(({message}) => {
        if (['Unauthorized', 'NoToken', 'TokenExpired'].includes(message)) {
          const loginUrl = customLoginUrl || config.loginUrl
          if (['NoToken', 'TokenExpired'].includes(message)) {
            let originalUrl

            if (serverContext) {
              originalUrl = serverContext.originalUrl
            } else if (isClient()) {
              originalUrl = `${window.location.pathname}${window.location.search}`
            }

            if (originalUrl) {
              redirect(`${loginUrl}${loginUrl.includes('?') ? '&' : '?'}redirectTo=${encodeURIComponent(originalUrl)}`)
            } else {
              redirect(loginUrl)
            }
          } else {
            redirect(loginUrl)
          }

          // Prevent errors from being thrown by Apollo.
          response.errors = null
          return true
        }
      })
    }
  })
}

export default getLoginRedirectLink
